import Vue from 'vue';

import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/mdi-v4/mdi-v4.css';
import 'quasar/dist/quasar.css';
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Screen from 'quasar/src/plugins/Screen.js';import LoadingBar from 'quasar/src/plugins/LoadingBar.js';import AddressbarColor from 'quasar/src/plugins/AddressbarColor.js';import Loading from 'quasar/src/plugins/Loading.js';import Dialog from 'quasar/src/plugins/Dialog.js';;
import materialIconsSet from 'quasar/icon-set/material-icons';

Vue.use(Quasar, {
  importStrategy: 'auto',
  cssAddon: true,
  components: [],
  directives: [],
  plugins: {
    Notify,
    Screen,
    LoadingBar,
    Loading,
    AddressbarColor,
    Dialog,
  },
  config: {
    // Default Notify config is set in `main.js`
  },
  iconSet: materialIconsSet,
  extras: ['line-awesome'],
});
